export enum BannerLinkTypeEnum {
    LINK = 'LINK',
    NO_LINK = 'NO_LINK',
    PRODUCT_FILTER = 'PRODUCT_FILTER',
}
